import BodyText from '../../atomsLegacy/typography/BodyText';
import { ValidationContainer } from './ValidationMessage.styles';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'src/components/atoms';
import FailureIcon from 'src/components/atomsLegacy/icons/FailureIcon';
import SuccessIcon from 'src/components/atomsLegacy/icons/SuccessIcon';
import { VaultLogo } from 'src/components/foundations/VaultLogo/VaultLogo';

export interface ValidationMessageProps {
  /**
   * Did the validation succeed
   */
  success?: boolean;
  /**
   * Waiting for feedback
   */
  feedback?: boolean;

  /**
   * New user email
   */
  email?: string;
  /**
   * Function for user to approve validation
   */
  validateEmail?: () => void;
  /**
   * Set the email for the login page
   */
  setEmailRedux?: (email: string) => void;
  showPortalLogin: boolean;
}

/**
 * Show the current question the user is on and their progress through the flow.
 */
export const ValidationMessage: React.FC<ValidationMessageProps> = ({
  success = false,
  feedback = true,
  email,
  validateEmail,
  setEmailRedux,
  showPortalLogin,
}: ValidationMessageProps) => {
  if (!success && feedback && validateEmail) {
    return (
      <ValidationContainer>
        <VaultLogo size="large" color="T300" />
        <p />
        <BodyText weight="regular" white={true}>
          Please approve your new email address
        </BodyText>
        <BodyText weight="regular" white={true}>
          Your password will not be changed.
        </BodyText>
        <p />
        <Button
          variant="primary"
          size="medium"
          width="120px"
          onClick={() => validateEmail()}
        >
          Approve
        </Button>
      </ValidationContainer>
    );
  }

  if (success && !feedback && setEmailRedux && email) {
    return (
      <ValidationContainer>
        <VaultLogo size="large" color="T300" />
        <p />
        <SuccessIcon />
        <BodyText weight="regular" white={true}>
          Thank you for validating your new email address {email}
        </BodyText>
        <BodyText weight="regular" white={true}>
          Your password has not changed.
        </BodyText>
        <p />
        {showPortalLogin && (
          <Link
            to="/login"
            onClick={() => {
              setEmailRedux(email);
            }}
          >
            <Button variant="primary" size="medium" width="120px">
              Log in
            </Button>
          </Link>
        )}
      </ValidationContainer>
    );
  }
  return (
    <ValidationContainer>
      <FailureIcon />
      <BodyText weight={'regular'} white={true}>
        A valid Token must be provided
      </BodyText>
    </ValidationContainer>
  );
};

export default ValidationMessage;
